import React from 'react';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import ChipWrapper from 'talent_matching/components/applied_filters/chip_wrapper';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import ClearableFilter from 'talent_matching/components/applied_filters/clearable_filter';
import { CompanyNameFilter } from 'talent_matching/types';

export type AppliedFilterChipProps = {
  label: string;
  text?: string;
  filterKeys: string[];
  uniqueKey: string;
  formDefaults: Record<string, unknown>;
};

const AppliedFilterChip = ({
  label,
  text,
  filterKeys,
  formDefaults,
}: AppliedFilterChipProps) => {
  const { reset, getValues } = useFormContext();

  const onRemove = () => {
    // We may need to reset multiple values, but React doesn't do well with multiple
    // calls to resetField. Removing multiple filters too quickly can also somehow change
    // the form defaults. So we build up the values and reset all at once.
    const values = getValues();
    const formKeys = filterKeys as string[];

    if (formKeys[0].includes('companyNameFilters')) {
      const [key, mode] = formKeys[0].split('.');
      values[key] = values[key].filter(
        (filter: CompanyNameFilter) => filter.mode !== mode
      );
    } else {
      formKeys.forEach((key) => {
        values[key] = formDefaults[key];
      });
    }

    reset(values);
  };

  return (
    <ChipWrapper>
      {text ? (
        <>
          <SecondaryBody medium dangerouslySetInnerHTML={{ __html: label }} />
          <ClearableFilter text={text} onRemove={onRemove} />
        </>
      ) : (
        <ClearableFilter text={label} onRemove={onRemove} />
      )}
    </ChipWrapper>
  );
};

export default AppliedFilterChip;
